import { render } from "./HomeOutlineIcon.vue?vue&type=template&id=28c0ef0e"
import script from "./HomeOutlineIcon.vue?vue&type=script&lang=js"
export * from "./HomeOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__